import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'

import { useCircleBoothApplyList } from '~/features/circle-participation/queries/useCircleApply'
import {
  circleStatusMap,
  CircleStatusType,
} from '~/features/circle-participation/utils/type'
import Back from '~/shared/assets/icons/Back'
import Sii2 from '~/shared/assets/images/sii2.png'
import LoadingScreen from '~/shared/components/loading/LoadingScreen'
import Pagination from '~/shared/components/pagination/Pagination'
import theme from '~/shared/styles/theme'

// TODO login 필요 페이지 따로 빼기

function CircleApplyListPage() {
  const navigate = useNavigate()

  const [page, setPage] = useState(1)

  const { isLoading, data } = useCircleBoothApplyList(page)

  if (isLoading) return <LoadingScreen />

  const { pageInfo, list: circleBoothApplyList } = data!

  const changePage = (event: any) => {
    setPage(Number(event.target.innerText))
  }

  return (
    <Wrapper>
      <>
        {circleBoothApplyList && (
          <>
            <BackBox onClick={() => navigate('/circle-participation/info')}>
              <Back />
              <span className="text">참가안내로 돌아가기</span>
            </BackBox>

            {circleBoothApplyList && circleBoothApplyList.length > 0 ? (
              <>
                <ListBox>
                  {circleBoothApplyList.map((applyCircle: any) => (
                    <List
                      key={applyCircle.id}
                      onClick={() =>
                        navigate(
                          `/circle-participation/apply-list/${applyCircle.id}`,
                        )
                      }
                    >
                      <div className="event_booth_box">
                        <div className="event_name">
                          {applyCircle.event_info.name}
                        </div>
                        <div className="booth_name">
                          {applyCircle.booth_name}
                        </div>
                      </div>
                      <StatusTag
                        $status={
                          CircleStatusType[
                            applyCircle.booth_status as keyof typeof CircleStatusType
                          ]
                        }
                      >
                        ⦁{'  '}
                        {circleStatusMap(
                          CircleStatusType[
                            applyCircle.booth_status as keyof typeof CircleStatusType
                          ],
                        )}
                      </StatusTag>
                    </List>
                  ))}
                </ListBox>

                <Pagination
                  page={page}
                  count={pageInfo.max_page}
                  onChange={changePage}
                />
              </>
            ) : (
              <>
                <SiiImage src={Sii2} alt="sii2" />
                <Desc>신청 내역이 없습니다.</Desc>
              </>
            )}
          </>
        )}
      </>
    </Wrapper>
  )
}

export default CircleApplyListPage

const Wrapper = styled.section`
  display: flex;
  flex-direction: column;
  gap: 60px;

  box-sizing: border-box;
  width: 100%;
  max-width: 1080px;
  min-height: calc(100vh - ${theme.size.headerHeight}px);
  margin: 0 auto;
  margin-top: ${theme.size.headerHeight}px;
  padding: 36px 24px;

  @media ${theme.device.medium} {
    gap: 40px;
    width: 100%;
    padding: 24px 20px;
  }
`
const BackBox = styled.div`
  cursor: pointer;

  display: flex;
  gap: 12px;
  align-items: center;

  margin-top: 20px;

  .text {
    font-family: NanumSquareNeo-Regular, sans-serif;
    font-size: 15px;
    font-weight: 400;
    line-height: 21px;
    color: ${theme.colors.grey_4};
  }
`

const ListBox = styled.div`
  display: flex;
  flex-direction: column;

  width: 100%;

  border: 1px solid ${theme.colors.grey_3};
  border-radius: 12px;

  @media ${theme.device.medium} {
    font-size: 14px;
  }
`

const List = styled.li`
  cursor: pointer;

  display: flex;
  align-items: center;
  justify-content: space-between;

  box-sizing: border-box;
  width: 100%;
  height: 100px;
  padding: 24px;

  line-height: 140%;

  border-bottom: 1px solid ${theme.colors.grey_2};

  .event_booth_box {
    display: flex;
    gap: 24px;

    @media ${theme.device.medium} {
      width: 80%;
    }
  }

  .event_name {
    color: ${theme.colors.grey_4};

    @media ${theme.device.medium} {
      width: 40%;
    }
  }

  .booth_name {
    font-weight: 600;

    @media ${theme.device.medium} {
      width: 40%;
    }
  }

  @media ${theme.device.medium} {
    padding: 12px;
  }
`

const SiiImage = styled.img`
  width: 580px;
  margin: 0 auto;

  @media ${theme.device.medium} {
    width: 100%;
  }
`

const Desc = styled.div`
  margin: 0 auto;

  font-family: NanumSquareNeo-Bold, sans-serif;
  font-size: 36px;
  font-weight: 500;
  line-height: 58.8px;

  @media ${theme.device.medium} {
    font-size: 24px;
    text-align: center;
  }
`

const StatusTag = styled.div<{ $status: string }>`
  display: flex;
  font-family: NanumSquareNeo-Bold, sans-serif;
  font-size: 24px;
  color: ${({ $status }) => {
    switch ($status) {
      case 'REVIEWING':
      case 'PAYMENT_REQUESTED':
      case 'REFUND_REQUESTED':
        return theme.colors.pink_3
      case 'MODIFICATION_REQUESTED':
        return theme.colors.warning
      case 'PARTICIPATION_COMPLETED':
        return theme.colors.mint_3
      default:
        return theme.colors.grey_4
    }
  }};

  @media ${theme.device.medium} {
    font-size: 14px;
  }
`
